import type { AppCopy } from '../catalogs';

export const skAppCopy = {
  welcomeHeading: 'Ako ti dnes môžem pomôcť?',
  thinking: 'Myslenie',
  scrollToBottom: 'Prejdite nadol',
  reasoning: 'Zdôvodnenie',
  reasoningInProgress: 'prebieha',
  citationPages: 'Strany {first}–{last}',
  citationTitle: 'Úryvok zo zdroja',
  citationLoading: 'Načítava sa zdroj…',
  citationUnavailable: 'Citovaný text nie je dostupný alebo k nemu už nemáte prístup.',
  citationOpen: 'Otvoriť zdroj',
  citationCopied: 'Citácia skopírovaná',
  copy: 'Kopírovať',
  more: 'Viac',
  tryAgain: 'Skúste to znova',
  answerTruncated: 'Odpoveď dosiahla limit dĺžky a bola orezaná.',
  continueAnswer: 'Pokračovať v odpovedi',
  exportMarkdown: 'Exportovať ako Markdown',
  edit: 'Upraviť',
  cancel: 'Zrušiť',
  update: 'Aktualizovať',
  previous: 'Predchádzajúce',
  next: 'Ďalej',
  messagePlaceholder: 'Odoslať správu…',
  projectHomePlaceholder: 'Nový chat: {project}',
  sharedChatEveryone: 'Všetci v spoločnosti {company} môžu čítať tento chat',
  sharedChatOnePerson: 'Tento chat môže čítať 1 osoba',
  sharedChatPeople: 'Počet ľudí, ktorí môžu čítať tento chat: {count}',
  forkedChatPlaceholder: 'Pokračujte so svojimi vlastnými pripojeniami…',
  newAnswer: 'Nová odpoveď',
  messageInput: 'Zadávanie správ',
  sendMessage: 'Odoslať správu',
  stopGenerating: 'Zastavte generovanie',
  addAttachment: 'Pridajte prílohu',
  removeFile: 'Odstrániť súbor',
  attachmentPreview: 'Ukážka prílohy',
  imageAttachmentPreview: 'Ukážka obrázkovej prílohy',
  image: 'Obrázok',
  openLink: 'otvoriť odkaz',
  document: 'Dokument',
  file: 'Súbor',
  attachment: 'príloha',
  uploadFailed: 'nahrávanie zlyhalo',
  uploading: 'nahrávanie',
  toolIncomplete: 'Nedokončené',
  toolActivity: 'Aktivita',
  activityThinking: 'Premýšľa…',
  activityWriting: 'Píše…',
  activityWaiting: 'Čaká na vaše schválenie',
  activityStopped: 'Zastavené',
  activityCouldNotFinish: 'Nepodarilo sa dokončiť',
  activitySources: 'zdrojov',
  activityShowThinking: 'Zobraziť premýšľanie',
  activityOpen: 'Otvoriť aktivitu',
  activitySteps: 'Kroky',
  activitySourcesTab: 'Zdroje',
  activityUnavailable: 'Táto aktivita nie je dostupná.',
  activityInput: 'Vstup',
  activityOutput: 'Výstup',
  activityNoSources: 'Odpoveď necituje žiadne zdroje.',
  activityApprovedByReply: 'Schválené vašou odpoveďou',

  toolRunning: 'Prebieha',
  toolComplete: 'Dokončené',
  toolNeedsApproval: 'Vyžaduje schválenie',
  toolInput: 'Vstup',
  toolCall: 'volanie nástroja',
  toolCalls: 'volania nástrojov',
  openMenu: 'Otvoriť menu',
  closeMenu: 'Zatvoriť ponuku',
  close: 'Zavrieť',
  showInTextField: 'Zobraziť v textovom poli',
  settings: 'Nastavenia',
  appearance: 'Vzhľad',
  themeLight: 'Svetlý',
  themeDark: 'Tmavý',
  themeSystem: 'Systémový',
  themeChoiceHelp:
    'Platí na všetkých vašich zariadeniach. Voľba „Systémový“ sa riadi svetlým alebo tmavým režimom každého zariadenia.',
  themeSaveFailed: 'Vzhľad sa nepodarilo uložiť, takže zostal nezmenený. Skúste to znova.',
  toolUsed: 'Použitý nástroj',
  toolCancelled: 'Zrušený nástroj',
  toolResult: 'výsledok:',
  toolError: 'Chyba:',
  toolCancelledReason: 'Dôvod zrušenia:',
  approvalAllow: 'Povoliť',
  approvalAlwaysAllow: 'Vždy povoľte',
  approvalDeny: 'Odmietnuť',
  approvalAlwaysDeny: 'Vždy odmietnuť',
  approvalConfirm: 'Potvrďte',
  approvalBack: 'Späť',
  approvalApprovedResult: 'Schválené používateľom',
  approvalDeniedResult: 'Používateľ zamietol spustenie nástroja',
  logout: 'Odhláste sa',
  loginOrCreateAccount: 'Prihláste sa / Vytvoriť účet',
  newChat: 'Nový chat',
  untitledChat: 'Chat bez názvu',
  previousChats: 'Predchádzajúce rozhovory',
  openChat: 'Otvorte chat {title}',
  moreActionsForChat: 'Ďalšie akcie pre {title}',
  chatActions: 'Chatové akcie',
  closeChatActions: 'Zavrieť akcie četu',
  deleteChatQuestion: 'Odstrániť čet?',
  deleteChatDescription: 'Chat „{title}“ bude natrvalo odstránený.',
  deleteChat: 'Odstrániť chat',
  keepChat: 'Ponechať chat',
  delete: 'Odstrániť',
  deleting: 'Odstraňuje sa…',
  chatDeleteFailed: 'Rozhovor sa nepodarilo odstrániť. Skúste to znova.',
  settingsDescription: 'Prispôsobte si, ako vám asistent pracuje.',
  settingsDesktopDescription: 'Prispôsobte si, ako na vás asistent reaguje.',
  personalization: 'Personalizácia',
  personalizationDescription:
    'Prispôsobte si pokyny, ktoré asistent dodržiava pri každej odpovedi.',
  languageAndRegion: 'Jazyk a región',
  languageAndRegionDescription: 'Vyberte jazyk a časové pásmo.',
  memories: 'Spomienky',
  memoriesDescription: 'Zobrazte, upravte alebo odstráňte, čo si o vás asistent pamätá.',
  account: 'účtu',
  accountDescription: 'Správa účtu a trvalé odstránenie vašich údajov.',
  backToSettings: 'Späť na nastavenia',
  closeSettings: 'Zatvorte nastavenia',
  settingsCategories: 'Kategórie nastavení',
  yourSettings: 'Vaše nastavenia',
  dataAndAccount: 'Údaje a účet',
  viewAndManageMemories: 'Zobrazte a spravujte, čo si asistent pamätá',
  loginToUseMemories: 'Ak chcete používať spomienky, prihláste sa',
  manageOrDeleteAccount: 'Spravujte alebo odstráňte účet',
  unsavedChanges: 'Máte neuložené zmeny',
  unsavedCloseDescription: 'Zatvorením nastavení sa zrušia zmeny na tejto stránke.',
  unsavedBackDescription: 'Prechodom späť zahodíte zmeny na tejto stránke.',
  continueEditing: 'Pokračujte v úpravách',
  discardChanges: 'Zahoďte zmeny',
  saveChanges: 'Uložiť zmeny',
  localSettingsNote: 'Uložené v tomto prehliadači. Prihláste sa a uložte do svojho účtu.',
  personality: 'Osobnosť',
  personalityHelp: 'Vlastné pokyny, ktoré asistent dodržiava pri každej odpovedi',
  personalityPlaceholder:
    'Napríklad: Buďte struční a konkrétni. Žijem v Göteborgu a mám rád vegetariánske jedlá.',
  timezone: 'Časové pásmo',
  searchTimezone: 'Hľadať časové pásma…',
  automaticBrowser: 'Automaticky (prehliadač)',
  saved: 'Uložené {date}',
  addMemory: 'Pridať spomienku',
  newMemory: 'Nová spomienka',
  memoryPlaceholder: 'Napríklad: Uprednostňujem krátke a konkrétne odpovede.',
  editMemory: 'Upraviť spomienku',
  saveMemory: 'Uložiť spomienku',
  deleteMemory: 'Vymazať spomienku',
  memorySaveFailed: 'Pamäť sa nepodarilo uložiť. Skúste to znova.',
  memoryLimitReached: 'Môžete uložiť až 50 spomienok. Pred pridaním ďalšej jednu vymažte.',
  memoryInvalid: 'Spomienky nemôžu obsahovať odkazy. Odstráňte odkaz a skúste to znova.',
  memoryDeleteFailed: 'Pamäť sa nepodarilo vymazať. Skúste to znova.',
  memoryLoadFailed: 'Spomienky sa nepodarilo načítať.',
  loadingMemories: 'Načítavajú sa spomienky…',
  emptyMemories:
    'Asistent ukladá spomienky na vás, keď hovoríte – čo sa vám páči, kde bývate a čo robíte. Tu ich môžete zobraziť, upraviť a odstrániť.',
  deleteAccountHelp:
    'Natrvalo odstráňte účet a všetky súvisiace rozhovory, spomienky a nastavenia.',
  deleteAccount: 'Odstrániť účet',
  deleteAccountQuestion: 'Chcete natrvalo odstrániť účet?',
  deleteAccountDescription:
    'Všetky chaty, správy, spomienky, nastavenia a prihlasovacie údaje budú odstránené. Túto akciu nie je možné vrátiť späť.',
  deleteAccountConfirm: 'Áno, odstrániť môj účet',
  accountDeleteFailed: 'Účet sa nepodarilo odstrániť. Nič nebolo odstránené – skúste to znova.',
  logoutEverywhereTitle: 'Všetky zariadenia',
  logoutEverywhereHelp:
    'Odhláste sa na všetkých zariadeniach a v prehliadačoch, kde je váš účet otvorený, vrátane tohto.',
  logoutEverywhere: 'Odhlásiť sa všade',
  logoutEverywhereQuestion: 'Odhlásiť sa na všetkých zariadeniach?',
  logoutEverywhereDescription:
    'Na všetkých zariadeniach a v prehliadačoch, vrátane tohto, sa budete musieť znova prihlásiť. Vaše chaty a nastavenia zostanú bez zmeny.',
  loggingOut: 'Odhlasovanie…',
  logoutEverywhereFailed:
    'Nepodarilo sa overiť, že ste boli odhlásení všade. Skúste to znova alebo na inom zariadení overte, či ste stále prihlásení.',
  settingsSaveFailed: 'Nastavenia sa nepodarilo uložiť. Skúste to znova.',
  customInstructions: 'Vlastné pokyny',
  notSet: 'Nie je nastavené',
  automaticLanguage: 'Automatický jazyk',
  automaticTimezone: 'automatické časové pásmo',
  appLanguage: 'Jazyk aplikácie',
  appLanguageHelp:
    'Ovláda celé rozhranie aplikácie a dátumy. Odpovede asistenta sa budú naďalej riadiť jazykom, v ktorom píšete.',
  automaticBrowserLanguage: 'Automaticky (jazyk prehliadača)',
  previousLanguageChoice: 'Predchádzajúca voľba: {language} ({locale})',
  previousLanguageChoiceCode: 'Predchádzajúca voľba ({locale})',
  canvasCopyLink: 'Kopírovať odkaz',
  canvasLinkCopied: 'Odkaz bol skopírovaný',
  actionUpdatedWithEdits: 'Aktualizované podľa vašich úprav',
  activityStepsDone:
    'one:krok dokončený|few:kroky dokončené|many:kroku dokončeného|other:krokov dokončených',
  activityResultsCount: 'one:výsledok|few:výsledky|many:výsledku|other:výsledkov',
  canvasCopyLinkFailed: 'Odkaz sa nepodarilo skopírovať',
  canvasOpenInAgent: 'Otvoriť v aplikácii {agent}',
  canvasExpand: 'Rozbaliť',
  canvasExitFullView: 'Ukončiť celé zobrazenie',
  webSourceUnread:
    'Odkaz v tejto odpovedi. Poneva túto stránku nečítala, takže tu nie je čo zobraziť.',
  webSourceOpenOriginal: 'Otvoriť originál',
  toolProgressSettings: 'Mením vaše nastavenia…',
  toolProgressAgent: 'Vytváram agenta…',
  toolProgressConnections: 'Hľadám možnosti pripojenia…',
  toolProgressResult: 'Pripravujem váš výsledok…',
  toolProgressClarification: 'Pripravujem spresnenie…',
  toolProgressKnowledge: 'Pripravujem navrhovanú aktualizáciu znalostí…',
  toolProgressQuestion: 'Pripravujem pre vás otázku…',
  toolProgressSkill: 'Tvoríme váš Skill…',
  toolErrorSettings: 'Vaše nastavenia sa nezmenili.',
  toolErrorAgent: 'Agenta sa nepodarilo vytvoriť.',
  toolErrorConnections: 'Možnosti pripojenia sa nepodarilo načítať.',
  toolErrorResult: 'Výsledok sa neuložil.',
  toolErrorClarification: 'Spresnenie sa nepodarilo pripraviť.',
  toolErrorKnowledge: 'Navrhovanú aktualizáciu znalostí sa nepodarilo pripraviť.',
  toolErrorQuestion: 'Otázku sa nepodarilo pripraviť.',
  toolErrorSkill: 'Koncept Skillu sa nepodarilo uložiť.',
  toolErrorOpenSettings: 'Otvoriť Nastavenia',
  toolErrorOpenAgents: 'Otvoriť Agentov',
  toolErrorOpenConnections: 'Otvoriť Pripojenia',
  toolStepIncomplete: 'Tento krok sa nedokončil.',
  toolEarlierAttemptsFailed:
    'one:predchádzajúci pokus neprešiel|few:predchádzajúce pokusy neprešli|many:predchádzajúceho pokusu neprešlo|other:predchádzajúcich pokusov neprešlo',
} satisfies AppCopy;
